import React from 'react';
import { number } from 'prop-types';

// eslint-disable-next-line @stylistic/max-len
const JIRA_MARK_PATH = 'M11.53 2c0 2.4 1.97 4.35 4.35 4.35h1.78v1.7c0 2.4 1.94 4.34 4.34 4.35V2.84a.84.84 0 0 0-.84-.84zM6.77 6.8a4.362 4.362 0 0 0 4.34 4.34h1.8v1.72a4.362 4.362 0 0 0 4.34 4.34V7.63a.841.841 0 0 0-.83-.83zM2 11.6c0 2.4 1.95 4.35 4.35 4.35h1.78v1.7c.01 2.4 1.95 4.34 4.35 4.35v-9.57a.84.84 0 0 0-.84-.83z';

const JiraIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role="img"
    aria-label="Jira"
    focusable="false"
  >
    <defs>
      <linearGradient id="jira-mark-gradient" x1="98%" y1="0%" x2="30%" y2="70%">
        <stop offset="18%" stopColor="#0052CC" />
        <stop offset="100%" stopColor="#2684FF" />
      </linearGradient>
    </defs>
    <path fill="url(#jira-mark-gradient)" d={JIRA_MARK_PATH} />
  </svg>
);

JiraIcon.propTypes = {
  size: number,
};

export default JiraIcon;
